// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BtnDownload_TheComp__VZwnU"};